<p-splitter
  [style]="{
    height: '100%',
    width: '100%',
  }"
  layout="vertical"
  [panelSizes]="[27, 73]"
>
  <ng-template pTemplate>
    <div style="width: 100%">
      @if (alertObjects().length > 0) {
        {{getAlertOverview()}}
      }
      <app-language-table/>
    </div>
  </ng-template>

  <ng-template pTemplate>
    <div style="width: 100%">
      <app-translation-table
        [languageRepo]="languageRef().languageRepo()"
        [alertObjects]="alertObjects()"
        (resolvedLanguage)="onLanguageResolved($event)"
      />
    </div>
  </ng-template>
</p-splitter>
